import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PendingApproval from "@/pages/PendingApproval";
import Dashboard from "@/pages/Dashboard";
import Tools from "@/pages/Tools";
import ToolDetail from "@/pages/ToolDetail";
import Categories from "@/pages/Categories";
import Locations from "@/pages/Locations";
import Transactions from "@/pages/Transactions";
import DamageReports from "@/pages/DamageReports";
import ToolRequests from "@/pages/ToolRequests";
import Maintenance from "@/pages/Maintenance";
import Users from "@/pages/Users";
import Layout from "@/components/Layout";

function Protected({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0C]">
        <div className="font-mono text-[#FF4F00] blink">// LOADING SHOP FLOOR //</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/pending-approval" element={<PendingApproval />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/tools" element={<Protected><Tools /></Protected>} />
      <Route path="/tools/:id" element={<Protected><ToolDetail /></Protected>} />
      <Route path="/categories" element={<Protected adminOnly><Categories /></Protected>} />
      <Route path="/locations" element={<Protected adminOnly><Locations /></Protected>} />
      <Route path="/transactions" element={<Protected><Transactions /></Protected>} />
      <Route path="/damage-reports" element={<Protected><DamageReports /></Protected>} />
      <Route path="/tool-requests" element={<Protected><ToolRequests /></Protected>} />
      <Route path="/maintenance" element={<Protected><Maintenance /></Protected>} />
      <Route path="/users" element={<Protected adminOnly><Users /></Protected>} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster
            theme="dark"
            toastOptions={{
              style: {
                background: "#121214",
                border: "1px solid #27272A",
                borderRadius: "2px",
                color: "#F5F5F5",
                fontFamily: "'IBM Plex Sans', system-ui, sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
